<div class="social-action-modal">
  <div class="title-wrap">
    <p>{{ data.modalTitle }}</p>
    <button title="close detail" (click)="closeDetail()">
      <mat-icon class="close-icon" aria-hidden="true" data-mat-icon-type="font"> close </mat-icon>
    </button>
  </div>
  @if (warningMessage && warningMessage.description && warningMessage.description !== '') {
    <div class="issue-container">
      <span class="warning-description">
        {{ warningMessage.description }}
        @if (warningMessage?.link?.url) {
          <a [href]="warningMessage?.link?.url" target="_blank">{{ warningMessage?.link?.text }}</a>
        }
      </span>
    </div>
  }
  <div class="social-modal-content">
    <span class="modal-text" [innerHtml]="data.text | safeHtml"></span>
  </div>
  <div class="social-action-modal-footer">
    @if (data.customButtonText) {
      <button id="btnCustomClicked" (click)="customButtonClicked()" class="secondary-button">
        {{ data.customButtonText }}
        @if (data.customButtonIcon) {
          <mat-icon class="social-modal-button-custom-icon" data-mat-icon-type="font">{{
            data.customButtonIcon
          }}</mat-icon>
        }
      </button>
    }
    @if (data.tertiaryButtonText) {
      <button id="btnCancelClicked" class="secondary-button" (click)="cancelButtonClicked()">
        {{ data.tertiaryButtonText }}
      </button>
    }
    @if (data.secondaryButtonText) {
      <button class="secondary-button" (click)="secondaryButtonClicked()">
        {{ data.secondaryButtonText }}
        @if (data.secondaryButtonIcon) {
          <mat-icon class="social-modal-button-secondary-icon" data-mat-icon-type="font">{{
            data.secondaryButtonIcon
          }}</mat-icon>
        }
      </button>
    }
    @if (data.primaryButtonText) {
      <button
        id="socialModalPrimaryButton"
        data-testid="social-modal-primary-button"
        (click)="confirmButtonClicked()"
        class="primary-button"
      >
        {{ data.primaryButtonText }}
        @if (data.primaryButtonIcon) {
          <mat-icon class="social-modal-button-primary-icon" data-mat-icon-type="font">{{
            data.primaryButtonIcon
          }}</mat-icon>
        }
      </button>
    }
  </div>
</div>
